import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
import { nameList } from './js/checkName.js'

// import GUI from 'lil-gui';


//debug
// const gui = new GUI();


// Tools
const lerp = (x, y, a) => x * (1 - a) + y * a;
const clamp = (a, min = 0, max = 1) => Math.min(max, Math.max(min, a));
const invlerp = (x, y, a) => clamp((a - x) / (y - x));
const range = (x1, y1, x2, y2, a) => lerp(x2, y2, invlerp(x1, y1, a));

function isNumeric(value) {
  return value.match(/^\d+((\/{1}|\-{1})\d+)*$/);
}


const desktop = window.matchMedia("(min-width: 1025px)").matches

const startEvent = desktop ? "mousedown" : "touchstart"
const endEvent = desktop ? "mouseup" : "touchend"
const moveEvent = desktop ? "mousemove" : "touchmove"

var textReady = true;
var state = "start";


const arrowRight=document.querySelector('.arrow-right');
const arrowLeft=document.querySelector('.arrow-left');

// Canvas
const canvas = document.querySelector('canvas.webgl')
const canvasCoffret = document.querySelector('canvas.coffret')

// Scene
const scene = new THREE.Scene()
const sceneCoffret = new THREE.Scene()

//Raycaster 
const raycaster = new THREE.Raycaster()
const fontLoader = new FontLoader();

/**
 * Sizes
 */
var sizes = {
  width: document.querySelector('.mhc-wrapper').clientWidth,
  height: document.querySelector('.mhc-wrapper').clientHeight
}

var sizesCoffret = {
  width: document.querySelector('.coffret').clientWidth,
  height: document.querySelector('.coffret').clientHeight
}

const box = {
  height: 2,
  width: .64
};


/**
 * Camera
 */

 var cameraView = desktop ? 38 : 40;

const camera = new THREE.PerspectiveCamera(cameraView, sizes.width / sizes.height,1,30)
scene.add(camera)

const cameraCoffret = new THREE.PerspectiveCamera(30, sizesCoffret.width / sizesCoffret.height,1,10)
cameraCoffret.position.x = 2.4
sceneCoffret.add(cameraCoffret)

var angleDef = 0;
var angleCam = 0;
var memoAngle = 0;
var heightCam = 0;

var mouseState = ""
/**
 * Renderer
 */

const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  alpha: false,
  antialias: true
})

renderer.setPixelRatio(window.devicePixelRatio);


const rendererCoffret = new THREE.WebGLRenderer({
  canvas: canvasCoffret,
  alpha: true,
  antialias: true
})

rendererCoffret.setPixelRatio(window.devicePixelRatio);

window.addEventListener('resize', onWindowResize);

function onWindowResize() {
  sizes = {
    width: document.querySelector('.mhc-wrapper').clientWidth,
    height: document.querySelector('.mhc-wrapper').clientHeight
  }
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();
  renderer.setSize(sizes.width, sizes.height);

  sizesCoffret = {
    width: document.querySelector('.coffret').clientWidth,
    height: document.querySelector('.coffret').clientHeight
  }

  cameraCoffret.aspect = sizesCoffret.width / sizesCoffret.height;
  cameraCoffret.updateProjectionMatrix();
  rendererCoffret.setSize(sizesCoffret.width, sizesCoffret.height);
}


/**
 * Orbit controls
 */

/*
const controls = new OrbitControls(camera, renderer.domElement);

controls.enableDamping = true;
controls.rotateSpeed = -.5;
controls.dampingFactor = .05;

controls.enableZoom = false;
controls.minPolarAngle = Math.PI / 2
controls.maxPolarAngle = Math.PI / 2

controls.minAzimuthAngle = 0
controls.maxAzimuthAngle = Math.PI
controls.enablePan=false
*/


const controlsCoffret = new OrbitControls(cameraCoffret, rendererCoffret.domElement);
controlsCoffret.enableDamping = true;
/*
controlsCoffret .rotateSpeed = .5;
controlsCoffret .dampingFactor = .05;
*/
controlsCoffret.enablePan = false

controlsCoffret.enableZoom = false;
controlsCoffret.minPolarAngle = Math.PI / 2 - Math.PI / 6
controlsCoffret.maxPolarAngle = Math.PI / 2 + Math.PI / 6

controlsCoffret.minAzimuthAngle = Math.PI / 6
controlsCoffret.maxAzimuthAngle = Math.PI + Math.PI / 6

/**
 * Loading manager
 */
let sceneReady = false

const loadingManager = new THREE.LoadingManager(
  // Loaded
  () => {
    onWindowResize();
    requestAnimationFrame(animate);
    window.setTimeout(() => {
      sceneReady = true
    }, 2000)
  },

  // Progress
  (itemUrl, itemsLoaded, itemsTotal) => {
    const progressRatio = itemsLoaded / itemsTotal
    console.log(itemUrl, itemsLoaded, itemsTotal)

  }
)

// scene.background = environmentMap;


/**
 * Textures
 */

const textureLoader = new THREE.TextureLoader(loadingManager);
const texture = textureLoader.load('https://conciergerie2022.netlify.app/textures/inside_def3.jpg') 


const frontTexture = textureLoader.load('https://conciergerie2022.netlify.app/textures/front2.jpg')
const backTexture = textureLoader.load('https://conciergerie2022.netlify.app/textures/back.jpg')
const sideTexture1 = textureLoader.load('https://conciergerie2022.netlify.app/textures/side1.jpg')
const sideTexture2 = textureLoader.load('https://conciergerie2022.netlify.app/textures/side1.jpg')
const topTexture = textureLoader.load('https://conciergerie2022.netlify.app/textures/top.jpg')
const bottomTexture = textureLoader.load('https://conciergerie2022.netlify.app/textures/bottom3.jpg')

/**
 * Material
 */
const mat = new THREE.MeshBasicMaterial({ map: texture, side: THREE.DoubleSide });

const front = new THREE.MeshBasicMaterial({ map: frontTexture });
const side1 = new THREE.MeshBasicMaterial({ map: sideTexture1 });
const side2 = new THREE.MeshBasicMaterial({ map: sideTexture2 });
const topSide = new THREE.MeshBasicMaterial({ map: topTexture });
const bottomSide = new THREE.MeshBasicMaterial({ map: bottomTexture });
const backSide = new THREE.MeshBasicMaterial({ map: backTexture });


var coffretMat = [
  side1,
  side2,
  bottomSide,
  topSide,
  front,
  backSide
];

/**
 * Objects
 */
var customBox = new THREE.Group();
sceneCoffret.add(customBox);

var coffret = new THREE.Mesh(
  new THREE.BoxGeometry(box.width, box.height, box.width),
  coffretMat
);
customBox.add(coffret)
customBox.scale.set(.55, .55, .55)
customBox.rotation.y = 2.13


var sphere = new THREE.SphereBufferGeometry(15, 200, 200);
var threeSixty = new THREE.Mesh(sphere, mat);
scene.add(threeSixty);
sphere.scale(-1, 1, 1);

threeSixty.position.x = -12

let points = [];

const geometry = new THREE.SphereGeometry(.1, 32, 16);
const material = new THREE.MeshBasicMaterial({ color: 0xffff00, transparent: true, opacity: 0 });


const point0 = new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({ color: 0xffff00 }));
sceneCoffret.add(point0);

const point1 = new THREE.Mesh(geometry, material);
const point2 = new THREE.Mesh(geometry, material);
const point3 = new THREE.Mesh(geometry, material);
const point4 = new THREE.Mesh(geometry, material);
const point5 = new THREE.Mesh(geometry, material);
const point6 = new THREE.Mesh(geometry, material);
const point7 = new THREE.Mesh(geometry, material);
const point8 = new THREE.Mesh(geometry, material);
const point9 = new THREE.Mesh(geometry, material);


scene.add(point1, point2, point3, point4, point5, point6, point7, point8, point9);

// var debug = {
//   angle: 1
// }


// gui.add(debug, 'angle', -Math.PI, Math.PI).onChange(value => {
//   customBox.rotation.y = value
// });
// gui.close();


// var angle = debug.angle;

//ajout panier 1
point1.position.x = -Math.cos(1.05) * 15
point1.position.z = -Math.sin(1.05) * 15
point1.position.y = Math.sin(-0.055) * 15
point1.element = document.querySelector('.mhdc-point-0')
points.push(point1);

//ajout panier 2
point2.position.x = -Math.cos(0.88) * 15
point2.position.z = -Math.sin(0.88) * 15
point2.position.y = Math.sin(-0.05) * 15
point2.element = document.querySelector('.mhdc-point-1')
points.push(point2);

//ajout panier 3
point3.position.x = -Math.cos(0.745) * 15
point3.position.z = -Math.sin(0.745) * 15
point3.position.y = Math.sin(-0.045) * 15
point3.element = document.querySelector('.mhdc-point-2')
points.push(point3);


//perso
point4.position.x = -Math.cos(0.042) * 15
point4.position.z = -Math.sin(0.042) * 15
point4.position.y = Math.sin(-0.06) * 15
point4.element = document.querySelector('.mhdc-point-3')
points.push(point4);


//a propos
point5.position.x = -Math.cos(-0.74) * 15
point5.position.z = -Math.sin(-0.74) * 15
point5.position.y = Math.sin(-0.05) * 15
point5.element = document.querySelector('.mhdc-point-4')
points.push(point5);


//le style
point6.position.x = -Math.cos(-1.57) * 15
point6.position.z = -Math.sin(-1.57) * 15
point6.position.y = Math.sin(-0.07) * 15
point6.element = document.querySelector('.mhdc-point-5')
points.push(point6);


//champagne grand vintage 2015
point7.position.x = -Math.cos(1.570) * 15
point7.position.z = -Math.sin(1.570) * 15
point7.position.y = Math.sin(-0.12) * 15
point7.element = document.querySelector('.mhdc-point-6')
points.push(point7);

//champagne rosé
point8.position.x = -Math.cos(1.450) * 15
point8.position.z = -Math.sin(1.450) * 15
point8.position.y = Math.sin(-0.065) * 15
point8.element = document.querySelector('.mhdc-point-7')
points.push(point8);

//moet imperial
point9.position.x = -Math.cos(1.680) * 15
point9.position.z = -Math.sin(1.680) * 15
point9.position.y = Math.sin(-0.065) * 15
point9.element = document.querySelector('.mhdc-point-8')
points.push(point9);

/**
  * text
  */

var textMaterial = new THREE.MeshBasicMaterial({ color: 0x000000 });
var text;

function add_text(nom, small) {

  fontLoader.load("https://conciergerie2022.netlify.app/fonts/matrix3.json", function (font) {

    var text2D = new TextGeometry(nom.toUpperCase(), {
      size: small ? .1 : .145,//.145
      height: .1,
      curveSegments: 12,
      font: font,
      bevelEnabled: true,
      bevelThickness: .0015,
      bevelSize: .001,
      bevelOffset: 0,
      bevelSegments: 3
    });


    text = new THREE.Mesh(text2D, textMaterial);

    var box = new THREE.Box3().setFromObject(text);

    text.rotation.z = Math.PI / 2;
    text.name = "3Dtext"

    var boxSize = new THREE.Vector3();
    box.getSize(boxSize);


    text.position.x = .07;
    text.position.z = .226;
    text.position.y = -boxSize.x / 2;

    textReady = true;
    customBox.add(text);

  })
}

const new_name = (name) => {

  if (textReady) {
    textReady = false;
    customBox.remove(text);
    add_text(name);
  }
}


add_text('Personnalisez-moi', true)


/**
 * Mouse
 */


const mouse = new THREE.Vector2()


window.addEventListener(moveEvent, (event) => {

  var iks = desktop ? event.clientX : event.touches[0].clientX
  var igrek = desktop ? event.clientY : event.touches[0].clientY

  if (state == "exp") {
    if (mouseState == "grabing") {
      var ratioX = desktop ? 2 : 0.75;
      angleCam = memoAngle + (mouse.x - (iks / sizes.width * 2 - 1))* ratioX
    } else if (mouseState != "arrow") {
      angleCam = memoAngle - (mouse.x - (iks / sizes.width * 2 - 1)) / 15
    } 

    heightCam = ((igrek / sizes.height) * 2 + 1) / 20
  } else {
    heightCam = 0;
  }

})

arrowLeft.addEventListener('mouseup', (event) => {
  mouseState = 'arrow';
  angleCam -= (Math.PI/6);
  setTimeout(function(){ 
    mouseState = 'free';
  }, 2000);

})

arrowRight.addEventListener('mouseup', (event) => {
  mouseState = 'arrow';
  angleCam += (Math.PI/6)
  setTimeout(function(){ 
    mouseState = 'free';
  }, 2000);
})

window.addEventListener(startEvent, (event) => {

  let iks = desktop ? event.clientX : event.touches[0].clientX
  let igrek = desktop ? event.clientY : event.touches[0].clientY

  mouse.x = iks / sizes.width * 2 - 1
  mouse.y = -(igrek / sizes.height) * 2 + 1
  memoAngle = angleCam

  mouseState = "grabing"
  canvas.classList.add('grabbing')

})

window.addEventListener(endEvent, (event) => {
  mouseState = "waiting"
  canvas.classList.remove('grabbing')
  memoAngle = angleCam
})



/**
 * Animate
 */
function animate() {
  requestAnimationFrame(animate);
  //controls.update();

  if (desktop) {
    angleCam = clamp(angleCam, -Math.PI / 2, Math.PI / 2)



    if(angleCam<-Math.PI / 2+.5){
      arrowLeft.classList.add('off')
    }else{
      arrowLeft.classList.remove('off')
    }
    if(angleCam>Math.PI / 2-.5){
      arrowRight.classList.add('off')
    }else{
      arrowRight.classList.remove('off')
    }

  } else {
    angleCam = clamp(angleCam, -Math.PI / 1.55, Math.PI / 1.7)
  }
  angleDef = lerp(angleDef, angleCam, .1)

  camera.position.y = lerp(camera.position.y, heightCam, .05)
  camera.position.x = Math.cos(angleDef) * 3
  camera.position.z = Math.sin(angleDef) * 3
  camera.lookAt(0, 0, 0);

  renderer.render(scene, camera);

  var lerpSpeed = state == "intro" ? .02 : .1

  if (state == "start") {
    lerpSpeed = 0;
  }

  if (threeSixty.position.x < -0.01) {
    threeSixty.position.x = lerp(threeSixty.position.x, 0, lerpSpeed)
  } else {
    threeSixty.position.x = 0
  }



  if (state == "perso") {
    controlsCoffret.update();
    rendererCoffret.render(sceneCoffret, cameraCoffret);
  }


  if (sceneReady) {
    for (const point of points) {
      const screenPosition = point.position.clone()
      screenPosition.project(camera)

      raycaster.setFromCamera(screenPosition, camera)
      const intersects = raycaster.intersectObjects(scene.children, true)

      if( intersects.length>0){
        const intersectionDistance = intersects[0].distance
      

      const pointDistance = point.position.distanceTo(camera.position)

      if (intersectionDistance > pointDistance) {
        // Hide
        point.element.classList.remove('visible')
      }
      // Intersection is further than the point
      else {
        // Show
        point.element.classList.add('visible')
      }
    }

      const translateX = screenPosition.x * sizes.width * 0.5 - 29
      const translateY = -screenPosition.y * sizes.height * 0.5 - 29

      point.element.style.transform = `translate(${translateX}px, ${translateY}px)`
    }
  }


}


/**
 * Intro
 */




const openExp = () => {
  state = "exp"
  document.querySelector('.mhdc-intro').classList.add('fade');
  document.querySelector('.mhdc-nav-indicator').classList.remove('mhdc-nav-indicator')
  document.querySelector('.mhc-wrapper').removeEventListener('click', openExp);
  document.querySelector('#mhc-btn1').classList.add('active')

}

document.querySelector('.mhdc-nav-indicator').addEventListener('click', openExp);



//checkname

const checkList = (name) => {

  if (isNumeric(name)) {
    return true
  }

  var result = nameList.filter(function (e) {
    var text1 = e.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    var text2 = name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    return text1 == text2
  })

  return result.length > 0
}


// Custom name form

let counter = 0;
let isValid = false;

const mhdcSteps = document.querySelectorAll('.mhdc-popin-item-content-step');
const mhdcValidate = document.querySelector('.validate-name');
const mhdcBasket = document.querySelector('.mhdc-btn-basket');
/*const backStep = document.querySelector('.mhdc-btn-custom');*/

// name validation (to be added)

document.querySelector('.mhdc-input-name').addEventListener('input', () => {
  var remain = 14 - document.querySelector('.mhdc-input-name').value.length;
  if (remain > 1) {
    document.querySelector('.mhdc-input-detail').innerHTML = remain + ' caractères restants';
  }
  else {
    document.querySelector('.mhdc-input-detail').innerHTML = remain + ' caractère restant';
  }
})



mhdcValidate.addEventListener('click', e => {
  e.preventDefault();

  var name = document.querySelector('.mhdc-input-name').value;

  if (checkList(name)) {
    errorMsg.classList.remove('visible');
    counter++;
    openStep()
    new_name(name)
  } else {
    errorMsg.classList.add('visible');
  }

})

mhdcBasket.addEventListener('click', e => {
  // e.preventDefault();
  counter++;
  openStep()
})

/*
backStep.addEventListener('click', e => {
  e.preventDefault();
  counter = 0;
  openStep()
})
*/

const openStep = () => {
  [...mhdcSteps].filter((q, j) => {
    if (j == counter) {
      q.classList.add('active')
    } else {
      q.classList.remove('active')
    }
  })
}




/**
 * Open popin
 */


const mhdcItems = document.querySelectorAll('.mhdc-btn-open');
const mhdcPopinContainer = document.querySelector('.mhdc-popin-container');
const mhdcPopins = document.querySelectorAll('.mhdc-popin-item');
const mhdcBack = document.querySelector('.mhdc-btn-back');
const mhdcPoints = document.querySelectorAll('.mhdc-point');
const errorMsg = document.querySelector('.mhdc-error-name');

mhdcItems.forEach((el, i) => {
  el.addEventListener('click', e => {
    e.preventDefault();
    filterPopin(i)
  })
})

mhdcPoints.forEach((el) => {
  el.addEventListener('click', e => {


    let i = el.getAttribute('data-index');
    console.log('click',i)
    if (i < 6) {
      e.preventDefault();
      filterPopin(i)
    }
  })
})

const filterPopin = (i) => {

  openStep()

  if (i == 0) {
    state = "perso"
    setTimeout(() => {
      document.querySelector('.mhdc-input-name').focus();
    }, 300)
  }

  mhdcPopinContainer.classList.add('active');
  [...mhdcPopins].filter((q, j) => {
    if (j == i) {
      q.classList.add('active')
    } else {
      q.classList.remove('active')
    }
  })
}

mhdcBack.addEventListener('click', e => {
  e.preventDefault();
  counter = 0;
  state = "exp"
  mhdcPopinContainer.classList.remove('active');
  mhdcPopins.forEach(el => {
    el.classList.remove('active')
  })
  errorMsg.classList.remove('visible');
})

// intro - start experience

const startXp = document.querySelectorAll('.mhdc-btn-start');
const introBlock = document.querySelector('.mhc-intro')

startXp.forEach(el => {
  el.addEventListener('click', e => {
    state = "intro"
    document.querySelector('.mhdc-intro').classList.add('visible');
    e.preventDefault();
    introBlock.classList.add('mhc-bkg-scale');
    document.querySelector('.mhc-intro-point').classList.add('mhd-scale-down');
    document.querySelector('.mhc-intro-bkg-overlay').addEventListener('transitionend', (event) => {
      introBlock.classList.remove('mhc-bkg-scale');
      introBlock.classList.add('mhdc-step-2');
    });

  })
})